import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "article__title" }
const _hoisted_2 = { class: "article__content" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Contact form", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_salesforce_contact_form = _resolveComponent("salesforce-contact-form")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, { full: true }, {
    default: _withCtx(() => [
      _createElementVNode("article", null, [
        _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", { innerHTML: _ctx.htmlContent }, null, 8, _hoisted_3),
          _hoisted_4,
          _hoisted_5,
          _createVNode(_component_salesforce_contact_form)
        ])
      ])
    ]),
    _: 1
  }))
}